// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {get, startCase, toLower} from 'lodash';

// Components
import DateRange from '../core/date-range';
import FormButtons from '../core/form-buttons';
import Input from '../core/input';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import Select from '../core/select';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import ServicesSearchForm from '../app/services-search-form';
import ServicesSearchPanelAction from '../app/services-search-panel-action';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './rules.scss';

const servicesDataKey = 'massActionResults';

class MassActionResults extends Component {
    getColumnConfig() {
        return [
            {
                dataKey: 'correlationId',
                link: '/investigation/mass-action-results',
                linkKey: 'correlationId',
                title: 'Correlation ID',
                type: 'link',
                width: '26%',
            },
            {
                dataKey: 'command',
                renderRowCallback: this.renderStatusCode,
                startCase: true,
                title: 'Command',
                width: '18%',
            },
            {
                dataKey: 'status',
                renderRowCallback: this.renderStatusCode,
                title: 'Status',
                width: '18%',
            },
            {
                dataKey: 'lastUpdated',
                title: 'Last Updated',
                type: 'date',
                format: 'MM/DD/YY hh:mm A',
                width: '22%',
            },
            {
                dataKey: 'lastModifiedBy',
                title: 'User',
                width: '16%',
            },
        ];
    }

    getPaginationProps() {
        const {query, totalPages} = this.props;

        return {
            maxPages: 9,
            query,
            totalPages,
        };
    }

    getRowDetails() {
        return {
            whitelistKeys: ['correlationId', 'command', 'status', 'lastUpdated', 'lastModifiedBy'],
        };
    }

    getTablewithsortProps() {
        return {
            activeRowValueKey: 'routerParams.ruleId',
            columnConfig: this.getColumnConfig(),
            formName: servicesDataKey,
            rowDetails: this.getRowDetails(),
            servicesDataKey,
            updateOnUrlChange: false,
            ...this.props,
        };
    }

    renderForm = () => (
        <ServicesSearchForm formName={servicesDataKey} servicesDataKey={servicesDataKey}>
            <Input label="Correlation ID" name="correlationId" title="Use wildcard (*) for partial match" />
            <Select label="Command" name="command">
                <option value="">Filter by Command</option>
                <option value="MAPPING">Mapping</option>
                <option value="REPUBLISH">Republish</option>
                <option value="SUNSET">Sunset</option>
            </Select>
            <Select label="Status" name="status">
                <option value="">Filter by Status</option>
                <option value="FAILED">Failed</option>
                <option value="RUNNING">Running</option>
                <option value="COMPLETED">Completed</option>
            </Select>
            <Input label="Username" name="lastModifiedBy" />
            <DateRange label="Last Updated" name="lastUpdated" />
            <FormButtons />
        </ServicesSearchForm>
    );

    renderStatusCode = (dataRow, {dataKey}) => startCase(toLower(get(dataRow, dataKey)));

    render() {
        const {searchData} = this.props;

        return (
            <div className="mass-action-results">
                <ServicesExportPanelAction searchData={searchData} />
                <ServicesSearchPanelAction contentRenderer={this.renderForm} />
                <SearchPagination {...this.getPaginationProps()} />
                <SearchTableWithSort {...this.getTablewithsortProps()} />
            </div>
        );
    }
}

MassActionResults.propTypes = {
    query: PropTypes.object,
    searchData: PropTypes.array,
    totalPages: PropTypes.number,
};

export default withSearch(MassActionResults, servicesDataKey);
